import Text from '@cartwhl/ui/base/Text';

import {
  ArrowsIcon,
  CheckmarkIcon,
  DevicesIcon,
  PersonIcon,
  TextIcon,
} from './icons';

const differentiationItems = [
  {
    icon: PersonIcon,
    title: 'Structured by design',
    description:
      'Motion is captured and generated into semantically-useful representations, not post-processed after the fact.',
  },
  {
    icon: TextIcon,
    title: 'Semantically Controllable',
    description:
      'Motion can be conditioned on intent, context, and style — not just physics.',
  },
  {
    icon: DevicesIcon,
    title: 'Scalable without degradation',
    description:
      'Synthetic generation and interpolation allow expansion without introducing noise typical of large capture efforts.',
  },
  {
    icon: ArrowsIcon,
    title: 'Cross-domain compatible',
    description:
      'The same underlying motion representations can serve animation, robotics, and simulation use cases.',
  },
  {
    icon: CheckmarkIcon,
    title: 'Proven in production systems',
    description:
      'Built on the same pipelines used by studios and interactive platforms.',
  },
];

export default function DifferentiationSection() {
  return (
    <section className="pb-(--vertical-spacing)">
      <div className="container">
        <Text
          as="h2"
          variant="web/display/xl"
          lg:variant="web/display/3xl"
          className="max-w-[360px] lg:max-w-[850px]"
        >
          Why Cartwheel motion data is different
        </Text>
        <div className="mt-12 grid gap-12 md:grid-cols-2 lg:mt-16 lg:grid-cols-12 lg:gap-x-4 lg:gap-y-20">
          {differentiationItems.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={item.title}
                className={`flex flex-col gap-6 lg:col-span-4 ${
                  index % 2 === 0 ? 'lg:col-start-2' : 'lg:col-start-8'
                }`}
              >
                <div className="text-green flex h-10 w-10 items-center justify-center">
                  <Icon className="h-12 w-12" />
                </div>
                <div className="flex flex-col gap-3">
                  <Text
                    as="h3"
                    variant="web/body/medium/lg"
                    lg:variant="web/body/medium/xl"
                  >
                    {item.title}
                  </Text>
                  <Text
                    as="p"
                    variant="web/body/medium/md"
                    lg:variant="web/body/medium/24"
                    className="text-tertiary"
                  >
                    {item.description}
                  </Text>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
